import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';

export default function RoofingPage() {
  const [showLeadForm, setShowLeadForm] = useState(false);
  const [showStickyBar, setShowStickyBar] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showCallbackForm, setShowCallbackForm] = useState(false);
  const [callbackSubmitted, setCallbackSubmitted] = useState(false);
  const [callbackData, setCallbackData] = useState({
    name: '',
    phone: '',
    email: '',
    preferredTime: 'morning',
    message: ''
  });
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    businessType: 'residential',
    teamSize: '1-2'
  });

  useEffect(() => {
    const handleScroll = () => {
      setShowStickyBar(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll);
    
    const timer = setTimeout(() => {
      if (!formSubmitted) {
        setShowLeadForm(true);
      }
    }, 8000);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(timer);
    };
  }, [formSubmitted]);

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('email', formData.email);
      formBody.append('phone', formData.phone);
      formBody.append('businessType', formData.businessType);
      formBody.append('teamSize', formData.teamSize);
      
      await fetch('https://readdy.ai/api/form/d69b95vmvg9ih2c79uk0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formBody.toString(),
      });
      
      setFormSubmitted(true);
      setShowLeadForm(false);
    } catch (error) {
      console.error('Form submission error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCallbackSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const formBody = new URLSearchParams();
      formBody.append('name', callbackData.name);
      formBody.append('phone', callbackData.phone);
      formBody.append('email', callbackData.email);
      formBody.append('preferredTime', callbackData.preferredTime);
      formBody.append('message', callbackData.message);
      
      await fetch('https://readdy.ai/api/form/d69b95vmvg9ih2c79ukg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formBody.toString(),
      });
      
      setCallbackSubmitted(true);
      setShowCallbackForm(false);
      setTimeout(() => setCallbackSubmitted(false), 5000);
    } catch (error) {
      console.error('Callback form submission error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const features = [
    {
      icon: 'ri-home-line',
      title: 'Roof Replacements',
      description: 'Generate comprehensive quotes for complete roof replacements including tear-off, underlayment, and new roofing materials with waste calculations.',
      price: 'From $8,500'
    },
    {
      icon: 'ri-tools-line',
      title: 'Roof Repairs',
      description: 'Quick quotes for leak repairs, tile replacements, flashing repairs, and storm damage with photo documentation.',
      price: 'From $350'
    },
    {
      icon: 'ri-drop-line',
      title: 'Guttering & Downpipes',
      description: 'Create detailed quotes for gutter installation, replacement, and repairs including leaf guards and downpipe extensions.',
      price: 'From $1,200'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Roof Inspections',
      description: 'Generate professional roof inspection reports with condition assessments, photos, and recommended maintenance schedules.',
      price: 'From $250'
    },
    {
      icon: 'ri-paint-line',
      title: 'Roof Restoration',
      description: 'Quote roof cleaning, repointing, resealing, and painting with material specifications and warranty information.',
      price: 'From $3,500'
    },
    {
      icon: 'ri-building-2-line',
      title: 'Commercial Roofing',
      description: 'Create quotes for commercial flat roofs, metal roofing, and industrial applications with compliance documentation.',
      price: 'From $15,000'
    }
  ];

  const stats = [
    { value: '16+', label: 'Hours Saved Weekly', icon: 'ri-time-line' },
    { value: '2,800+', label: 'Roofers Using It', icon: 'ri-team-line' },
    { value: '91%', label: 'Quote Win Rate', icon: 'ri-trophy-line' },
    { value: '$18K', label: 'Avg Monthly Revenue Increase', icon: 'ri-money-dollar-circle-line' }
  ];

  const testimonials = [
    {
      name: 'Chris Anderson',
      business: 'Anderson Roofing Solutions',
      specialty: 'Residential Re-roofing',
      image: 'https://public.readdy.ai/ai/img_res/b489a26157ddc6d5798b98c2c9c801f3.jpg',
      quote: 'The roof measurement integration is incredible. I can now quote a complete re-roof in 20 minutes instead of spending hours on-site measuring. My accuracy has improved dramatically.',
      results: 'Increased monthly revenue by $22,000'
    },
    {
      name: 'Jenny Walsh',
      business: 'Walsh Roofing & Gutters',
      specialty: 'Guttering Specialist',
      image: 'https://readdy.ai/api/search-image?query=professional%20female%20roofer%20with%20premium%20guttering%20equipment%20and%20tools%20wearing%20quality%20work%20clothes%20and%20safety%20gear%20confident%20pose%20on%20luxury%20residential%20setting%20natural%20daylight%20showing%20expertise%20and%20professionalism%20cinematic%20photography&width=400&height=400&seq=roof-test-premium-2&orientation=squarish',
      quote: 'Quoting gutter jobs used to be tedious with all the linear measurements. Now the system calculates everything automatically including corners and downpipes. Game changer!',
      results: 'Won 25 gutter jobs in 6 weeks'
    },
    {
      name: 'Tom Richards',
      business: 'Richards Commercial Roofing',
      specialty: 'Commercial & Industrial',
      image: 'https://readdy.ai/api/search-image?query=experienced%20roofer%20on%20commercial%20building%20rooftop%20with%20industrial%20roofing%20equipment%20wearing%20safety%20gear%20professional%20appearance%20modern%20building%20background%20natural%20lighting%20showing%20expertise%20and%20quality%20workmanship%20ultra%20sharp%20cinematic%20quality&width=400&height=400&seq=roof-test-premium-3&orientation=squarish',
      quote: 'Managing multiple commercial roofing projects was overwhelming. Now I can generate detailed quotes with compliance docs in minutes and track everything in one place.',
      results: 'Secured 6 major commercial contracts'
    }
  ];

  const supplierPricing = [
    {
      category: 'Roofing Materials',
      items: ['Colorbond sheets', 'Concrete tiles', 'Terracotta tiles', 'Asphalt shingles'],
      icon: 'ri-stack-line'
    },
    {
      category: 'Guttering',
      items: ['Colorbond gutters', 'Downpipes', 'Leaf guards', 'Gutter brackets'],
      icon: 'ri-drop-line'
    },
    {
      category: 'Underlayment',
      items: ['Sarking', 'Insulation batts', 'Vapour barriers', 'Roof blankets'],
      icon: 'ri-layout-4-line'
    },
    {
      category: 'Fixings & Flashings',
      items: ['Roof screws', 'Ridge capping', 'Valley irons', 'Lead flashings'],
      icon: 'ri-settings-3-line'
    }
  ];

  const caseStudies = [
    {
      title: 'Residential Re-roofing Business Growth',
      roofer: 'Top Notch Roofing Melbourne',
      challenge: 'Struggled to provide quick, accurate quotes for re-roofing jobs. Lost jobs to competitors with faster turnaround times.',
      solution: 'Implemented automated roof quoting with satellite measurement integration and real-time material pricing.',
      results: [
        'Quote generation time reduced from 4 hours to 25 minutes',
        'Re-roofing job bookings increased by 320%',
        'Average job value increased from $12,000 to $16,500',
        'Customer satisfaction score improved to 4.9/5'
      ],
      image: 'https://readdy.ai/api/search-image?query=beautiful%20luxury%20residential%20house%20with%20new%20premium%20colorbond%20metal%20roof%20being%20installed%20by%20professional%20roofers%20sunny%20day%20australian%20suburban%20setting%20showing%20quality%20workmanship%20gleaming%20modern%20roofing%20materials%20and%20expert%20installation%20cinematic%20lighting&width=800&height=500&seq=roof-case-premium-1&orientation=landscape'
    },
    {
      title: 'Storm Damage Response Efficiency',
      roofer: 'Rapid Roof Repairs Brisbane',
      challenge: 'After major storms, demand for quotes overwhelmed the team. Slow response times meant losing jobs to competitors.',
      solution: 'Adopted mobile quoting system with photo documentation and instant quote generation capabilities.',
      results: [
        'Response time reduced from 3 days to same-day',
        'Storm damage repairs increased by 450%',
        'Quote accuracy improved by 95%',
        'Revenue doubled during storm season'
      ],
      image: 'https://readdy.ai/api/search-image?query=professional%20roofer%20repairing%20storm%20damaged%20roof%20with%20premium%20replacement%20tiles%20and%20safety%20equipment%20residential%20setting%20showing%20quality%20repair%20work%20in%20progress%20expert%20craftsmanship%20natural%20lighting%20ultra%20sharp%20cinematic%20photography&width=800&height=500&seq=roof-case-premium-2&orientation=landscape'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Floating Callback Button */}
      <button
        onClick={() => setShowCallbackForm(true)}
        className="fixed left-6 bottom-6 z-40 flex items-center gap-3 px-5 py-4 bg-gradient-to-r from-slate-700 to-slate-800 text-white rounded-full shadow-2xl hover:shadow-slate-500/30 hover:scale-105 transition-all duration-300 cursor-pointer group"
      >
        <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center group-hover:bg-white/30 transition-colors">
          <i className="ri-phone-line text-xl"></i>
        </div>
        <div className="pr-2">
          <div className="font-semibold text-sm whitespace-nowrap">Request Callback</div>
          <div className="text-slate-300 text-xs whitespace-nowrap">We'll call you back</div>
        </div>
      </button>

      {/* Callback Request Modal */}
      {showCallbackForm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
          <div className="relative bg-white rounded-3xl shadow-2xl max-w-md w-full overflow-hidden animate-in fade-in zoom-in duration-300">
            <button
              onClick={() => setShowCallbackForm(false)}
              className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 transition-colors cursor-pointer z-10"
            >
              <i className="ri-close-line text-xl text-gray-600"></i>
            </button>
            
            <div className="bg-gradient-to-br from-slate-700 to-slate-800 p-8 text-white">
              <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mb-4">
                <i className="ri-phone-line text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold mb-2">Request a Callback</h3>
              <p className="text-slate-300">Leave your details and we'll call you back within 2 hours during business hours.</p>
            </div>
            
            <form 
              id="roofing-callback-form"
              data-readdy-form
              onSubmit={handleCallbackSubmit}
              className="p-8 space-y-4"
            >
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Your Name *</label>
                <input
                  type="text"
                  name="name"
                  required
                  value={callbackData.name}
                  onChange={(e) => setCallbackData({...callbackData, name: e.target.value})}
                  className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-slate-500 focus:ring-2 focus:ring-slate-500/20 outline-none transition-all text-sm"
                  placeholder="John Smith"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Phone Number *</label>
                <input
                  type="tel"
                  name="phone"
                  required
                  value={callbackData.phone}
                  onChange={(e) => setCallbackData({...callbackData, phone: e.target.value})}
                  className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-slate-500 focus:ring-2 focus:ring-slate-500/20 outline-none transition-all text-sm"
                  placeholder="0412 345 678"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Email Address</label>
                <input
                  type="email"
                  name="email"
                  value={callbackData.email}
                  onChange={(e) => setCallbackData({...callbackData, email: e.target.value})}
                  className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-slate-500 focus:ring-2 focus:ring-slate-500/20 outline-none transition-all text-sm"
                  placeholder="john@email.com (optional)"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Preferred Call Time</label>
                <select
                  name="preferredTime"
                  value={callbackData.preferredTime}
                  onChange={(e) => setCallbackData({...callbackData, preferredTime: e.target.value})}
                  className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-slate-500 focus:ring-2 focus:ring-slate-500/20 outline-none transition-all text-sm cursor-pointer"
                >
                  <option value="morning">Morning (9am - 12pm)</option>
                  <option value="afternoon">Afternoon (12pm - 5pm)</option>
                  <option value="evening">Evening (5pm - 7pm)</option>
                  <option value="anytime">Anytime</option>
                </select>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">What can we help with?</label>
                <textarea
                  name="message"
                  value={callbackData.message}
                  onChange={(e) => setCallbackData({...callbackData, message: e.target.value.slice(0, 500)})}
                  rows={3}
                  maxLength={500}
                  className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-slate-500 focus:ring-2 focus:ring-slate-500/20 outline-none transition-all text-sm resize-none"
                  placeholder="Tell us briefly what you'd like to discuss..."
                />
                <div className="text-xs text-gray-400 text-right mt-1">{callbackData.message.length}/500</div>
              </div>
              
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full py-4 bg-gradient-to-r from-slate-700 to-slate-800 text-white rounded-xl font-semibold hover:from-slate-800 hover:to-slate-900 transition-all duration-300 shadow-lg hover:shadow-xl disabled:opacity-50 cursor-pointer whitespace-nowrap"
              >
                {isSubmitting ? (
                  <span className="flex items-center justify-center gap-2">
                    <i className="ri-loader-4-line animate-spin"></i>
                    Submitting...
                  </span>
                ) : (
                  <span className="flex items-center justify-center gap-2">
                    <i className="ri-phone-line"></i>
                    Request Callback
                  </span>
                )}
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Callback Success Toast */}
      {callbackSubmitted && (
        <div className="fixed bottom-6 left-6 z-50 bg-slate-700 text-white px-6 py-4 rounded-2xl shadow-2xl flex items-center gap-3 animate-in slide-in-from-bottom duration-300">
          <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
            <i className="ri-check-line text-2xl"></i>
          </div>
          <div>
            <div className="font-bold">Callback Requested!</div>
            <div className="text-slate-300 text-sm">We'll call you back soon</div>
          </div>
        </div>
      )}

      {/* Floating Lead Capture Form */}
      {showLeadForm && !formSubmitted && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
          <div className="relative bg-white rounded-3xl shadow-2xl max-w-lg w-full overflow-hidden animate-in fade-in zoom-in duration-300">
            <button
              onClick={() => setShowLeadForm(false)}
              className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-xl text-gray-600"></i>
            </button>
            
            <div className="bg-gradient-to-br from-slate-700 to-slate-800 p-8 text-white">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-white/20 rounded-full text-sm font-medium mb-4">
                <i className="ri-gift-line"></i>
                Limited Time Offer
              </div>
              <h3 className="text-2xl font-bold mb-2">Get Your Free Roofing Business Audit</h3>
              <p className="text-slate-300">Plus 30-day extended trial when you book a demo today</p>
            </div>
            
            <form 
              id="roofing-lead-form"
              data-readdy-form
              onSubmit={handleFormSubmit}
              className="p-8 space-y-4"
            >
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Your Name</label>
                <input
                  type="text"
                  name="name"
                  required
                  value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                  className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-slate-500 focus:ring-2 focus:ring-slate-500/20 outline-none transition-all text-sm"
                  placeholder="John Smith"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Email Address</label>
                <input
                  type="email"
                  name="email"
                  required
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                  className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-slate-500 focus:ring-2 focus:ring-slate-500/20 outline-none transition-all text-sm"
                  placeholder="john@roofing.com.au"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Phone Number</label>
                <input
                  type="tel"
                  name="phone"
                  required
                  value={formData.phone}
                  onChange={(e) => setFormData({...formData, phone: e.target.value})}
                  className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-slate-500 focus:ring-2 focus:ring-slate-500/20 outline-none transition-all text-sm"
                  placeholder="0412 345 678"
                />
              </div>
              
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Specialization</label>
                  <select
                    name="businessType"
                    value={formData.businessType}
                    onChange={(e) => setFormData({...formData, businessType: e.target.value})}
                    className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-slate-500 focus:ring-2 focus:ring-slate-500/20 outline-none transition-all text-sm cursor-pointer"
                  >
                    <option value="residential">Residential</option>
                    <option value="commercial">Commercial</option>
                    <option value="repairs">Repairs</option>
                    <option value="guttering">Guttering</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Team Size</label>
                  <select
                    name="teamSize"
                    value={formData.teamSize}
                    onChange={(e) => setFormData({...formData, teamSize: e.target.value})}
                    className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-slate-500 focus:ring-2 focus:ring-slate-500/20 outline-none transition-all text-sm cursor-pointer"
                  >
                    <option value="1-2">Just me / 1-2</option>
                    <option value="3-5">3-5 people</option>
                    <option value="6-10">6-10 people</option>
                    <option value="10+">10+ people</option>
                  </select>
                </div>
              </div>
              
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full py-4 bg-gradient-to-r from-slate-700 to-slate-800 text-white rounded-xl font-semibold hover:from-slate-800 hover:to-slate-900 transition-all duration-300 shadow-lg hover:shadow-xl disabled:opacity-50 cursor-pointer whitespace-nowrap"
              >
                {isSubmitting ? (
                  <span className="flex items-center justify-center gap-2">
                    <i className="ri-loader-4-line animate-spin"></i>
                    Submitting...
                  </span>
                ) : (
                  <span className="flex items-center justify-center gap-2">
                    <i className="ri-calendar-check-line"></i>
                    Get My Free Audit + Demo
                  </span>
                )}
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Sticky Bottom CTA Bar */}
      {showStickyBar && !formSubmitted && (
        <div className="fixed bottom-0 left-0 right-0 z-40 bg-gradient-to-r from-slate-700 to-slate-800 shadow-2xl shadow-black/20 transform transition-transform duration-300">
          <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <div className="hidden sm:flex items-center gap-2 px-3 py-1.5 bg-white/20 rounded-full">
                <i className="ri-home-line text-white"></i>
                <span className="text-white text-sm font-medium">Roofers Only</span>
              </div>
              <div className="text-white">
                <div className="font-bold text-lg">Get 30% Off Your First 3 Months</div>
                <div className="text-slate-300 text-sm hidden sm:block">Plus free business audit worth $499</div>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <button
                onClick={() => setShowLeadForm(true)}
                className="px-6 py-3 bg-white text-slate-700 rounded-lg font-semibold hover:bg-gray-100 transition-all duration-300 shadow-lg cursor-pointer whitespace-nowrap"
              >
                <i className="ri-gift-line mr-2"></i>
                Claim Offer
              </button>
              <button
                onClick={() => setShowStickyBar(false)}
                className="p-2 text-white/80 hover:text-white transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Success Toast */}
      {formSubmitted && (
        <div className="fixed bottom-6 right-6 z-50 bg-emerald-600 text-white px-6 py-4 rounded-2xl shadow-2xl flex items-center gap-3 animate-in slide-in-from-bottom duration-300">
          <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
            <i className="ri-check-line text-2xl"></i>
          </div>
          <div>
            <div className="font-bold">Thanks! We'll be in touch soon</div>
            <div className="text-emerald-100 text-sm">Check your email for confirmation</div>
          </div>
        </div>
      )}

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-100 via-gray-100 to-slate-50"></div>
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-20 left-10 w-72 h-72 bg-slate-500 rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-slate-600 rounded-full blur-3xl"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-slate-200 rounded-full mb-6">
                <i className="ri-home-line text-slate-700"></i>
                <span className="text-sm font-medium text-slate-800">For Professional Roofers</span>
              </div>
              
              <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
                Roofing Quoting<br />
                <span className="text-slate-700">Made Simple</span>
              </h1>
              
              <p className="text-xl text-gray-600 mb-8 leading-relaxed">
                Generate professional roofing quotes in minutes. From re-roofs to repairs, 
                streamline your quoting process and win more jobs with accurate, detailed estimates.
              </p>
              
              <div className="flex flex-wrap gap-4 mb-8">
                <Link 
                  to="/demo" 
                  className="px-8 py-4 bg-slate-800 text-white rounded-lg font-semibold hover:bg-slate-900 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
                >
                  Book Free Demo
                </Link>
                <Link 
                  to="/invoice-demo" 
                  className="px-8 py-4 bg-white text-slate-700 rounded-lg font-semibold border-2 border-slate-700 hover:bg-slate-50 transition-all duration-300 whitespace-nowrap"
                >
                  Try Quote Generator
                </Link>
              </div>
              
              <div className="flex items-center gap-6 text-sm text-gray-600">
                <div className="flex items-center gap-2">
                  <i className="ri-time-line text-slate-700"></i>
                  <span><strong className="text-gray-900">4.2 min</strong> avg quote time</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-shield-check-line text-slate-700"></i>
                  <span>Satellite Measurements</span>
                </div>
              </div>
            </div>
            
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-slate-600 to-slate-800 rounded-3xl transform rotate-3"></div>
              <img 
                src="https://readdy.ai/api/search-image?query=professional%20australian%20roofer%20on%20luxury%20residential%20rooftop%20installing%20premium%20colorbond%20metal%20roofing%20wearing%20safety%20harness%20and%20hard%20hat%20with%20gleaming%20roofing%20materials%20and%20professional%20tools%20blue%20sky%20background%20showing%20expertise%20safety%20compliance%20and%20quality%20workmanship%20cinematic%20lighting&width=600&height=700&seq=roof-hero-premium-1&orientation=portrait"
                alt="Professional Roofer"
                className="relative rounded-3xl shadow-2xl w-full h-auto object-cover"
              />
              <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-xl p-6 max-w-xs">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                    <i className="ri-check-line text-2xl text-green-600"></i>
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-gray-900">$18,500</div>
                    <div className="text-sm text-gray-600">Re-roof quote sent in 15 min</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-slate-800">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-slate-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${stat.icon} text-3xl text-white`}></i>
                </div>
                <div className="text-4xl font-bold text-white mb-2">{stat.value}</div>
                <div className="text-slate-400">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Roofing Trade Features
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Everything you need to quote roofing jobs quickly and accurately
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <div 
                key={index}
                className="group bg-white border-2 border-gray-100 rounded-2xl p-8 hover:border-slate-600 hover:shadow-xl transition-all duration-300"
              >
                <div className="w-16 h-16 bg-slate-100 rounded-xl flex items-center justify-center mb-6 group-hover:bg-slate-700 transition-colors duration-300">
                  <i className={`${feature.icon} text-3xl text-slate-700 group-hover:text-white transition-colors duration-300`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
                <p className="text-gray-600 mb-4 leading-relaxed">{feature.description}</p>
                <div className="text-slate-700 font-semibold">{feature.price}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Supplier Pricing Integration */}
      <section className="py-20 bg-gradient-to-br from-slate-100 to-gray-100">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Real-Time Roofing Material Pricing
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Integrated pricing from major Australian roofing suppliers
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {supplierPricing.map((category, index) => (
              <div 
                key={index}
                className="bg-white rounded-xl p-6 border-2 border-slate-200 shadow-lg"
              >
                <div className="w-12 h-12 bg-slate-700 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${category.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-4">{category.category}</h3>
                <ul className="space-y-2">
                  {category.items.map((item, idx) => (
                    <li key={idx} className="flex items-start gap-2 text-sm text-gray-700">
                      <i className="ri-check-line text-slate-600 mt-0.5"></i>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <p className="text-gray-600 mb-6">Integrated with leading suppliers:</p>
            <div className="flex flex-wrap justify-center gap-8 items-center">
              <div className="text-2xl font-bold text-gray-400">Stratco</div>
              <div className="text-2xl font-bold text-gray-400">BlueScope</div>
              <div className="text-2xl font-bold text-gray-400">Lysaght</div>
              <div className="text-2xl font-bold text-gray-400">Monier</div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Trusted by Roofers Across Australia
            </h2>
            <p className="text-xl text-gray-600">
              See how roofers are growing their businesses
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div 
                key={index}
                className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300"
              >
                <div className="flex items-center gap-4 mb-6">
                  <img 
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-16 h-16 rounded-full object-cover"
                  />
                  <div>
                    <div className="font-bold text-gray-900">{testimonial.name}</div>
                    <div className="text-sm text-gray-600">{testimonial.business}</div>
                    <div className="text-xs text-slate-600 font-medium">{testimonial.specialty}</div>
                  </div>
                </div>
                
                <div className="flex gap-1 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-amber-400"></i>
                  ))}
                </div>
                
                <p className="text-gray-700 mb-4 leading-relaxed">"{testimonial.quote}"</p>
                
                <div className="pt-4 border-t border-gray-100">
                  <div className="flex items-center gap-2 text-sm font-semibold text-green-600">
                    <i className="ri-arrow-up-line"></i>
                    {testimonial.results}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Case Studies */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Roofing Business Success Stories
            </h2>
            <p className="text-xl text-gray-600">
              Real results from roofers who transformed their businesses
            </p>
          </div>

          <div className="space-y-16">
            {caseStudies.map((study, index) => (
              <div 
                key={index}
                className="bg-gradient-to-br from-gray-50 to-slate-50 rounded-3xl overflow-hidden shadow-xl"
              >
                <div className="grid lg:grid-cols-2 gap-8">
                  <div className="p-12">
                    <div className="inline-block px-4 py-2 bg-slate-700 text-white rounded-full text-sm font-semibold mb-6">
                      Case Study
                    </div>
                    <h3 className="text-3xl font-bold text-gray-900 mb-4">{study.title}</h3>
                    <div className="text-slate-700 font-semibold mb-6">{study.roofer}</div>
                    
                    <div className="space-y-6">
                      <div>
                        <h4 className="font-bold text-gray-900 mb-2 flex items-center gap-2">
                          <i className="ri-error-warning-line text-red-500"></i>
                          Challenge
                        </h4>
                        <p className="text-gray-700">{study.challenge}</p>
                      </div>
                      
                      <div>
                        <h4 className="font-bold text-gray-900 mb-2 flex items-center gap-2">
                          <i className="ri-lightbulb-line text-slate-600"></i>
                          Solution
                        </h4>
                        <p className="text-gray-700">{study.solution}</p>
                      </div>
                      
                      <div>
                        <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                          <i className="ri-trophy-line text-green-600"></i>
                          Results
                        </h4>
                        <ul className="space-y-2">
                          {study.results.map((result, idx) => (
                            <li key={idx} className="flex items-start gap-2 text-gray-700">
                              <i className="ri-check-line text-green-600 mt-1"></i>
                              <span>{result}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                  
                  <div className="relative h-full min-h-[400px]">
                    <img 
                      src={study.image}
                      alt={study.title}
                      className="absolute inset-0 w-full h-full object-cover"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-slate-700 to-slate-900 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        </div>
        
        <div className="relative max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Ready to Transform Your Roofing Business?
          </h2>
          <p className="text-xl text-slate-300 mb-8">
            Join 2,800+ roofers who are quoting faster, winning more jobs, and growing their revenue
          </p>
          
          <div className="flex flex-wrap justify-center gap-4 mb-8">
            <Link 
              to="/demo" 
              className="px-8 py-4 bg-white text-slate-700 rounded-lg font-semibold hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              Book Your Free Demo
            </Link>
            <Link 
              to="/invoice-demo" 
              className="px-8 py-4 bg-slate-600 text-white rounded-lg font-semibold hover:bg-slate-500 transition-all duration-300 border-2 border-white whitespace-nowrap"
            >
              Try Quote Generator
            </Link>
          </div>
          
          <div className="flex flex-wrap justify-center gap-6 text-slate-300">
            <div className="flex items-center gap-2">
              <i className="ri-check-line"></i>
              <span>No credit card required</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-check-line"></i>
              <span>14-day free trial</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-check-line"></i>
              <span>Cancel anytime</span>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
